import { Box, Tab, Tabs } from '@mui/material'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { setPageName } from '../../store/redux/reducers/pageNameSlice'
import { useAppDispatch } from '../../store/redux/hooks'
import PermissionsTable from '../../components/Table/PermissionsTable'
import { TabContext, TabPanel } from '@mui/lab'
import RoleDetailTable from '../../components/Table/RoleDetailTable'
import { styled } from '@mui/system'
import { typography } from '../../styles/theme-configuration/typography'
import { pageHeaderActions } from '../../store/redux/reducers/pageHeaderSlice'
import { breadcrumbsItemsActions } from '../../store/redux/reducers/breadcrumbsSlice'

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: typography.h5.fontWeight,
  fontSize: typography.h5.fontSize,
  fontFamily: typography.h5.fontFamily,
  color: theme.palette.text.mediumEmphasis,
  '&.Mui-selected': {
    color: theme.palette.text.highEmphasis,
  },
}))

const AccessibilitySettingsView = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [tabIndex, setTabIndex] = React.useState('roles')

  useEffect(() => {
    dispatch(setPageName(t('page.name.accessibilitySettings')))
    dispatch(pageHeaderActions.setInitialState())
    dispatch(breadcrumbsItemsActions.setInitialState())
    dispatch(
      breadcrumbsItemsActions.setSelectedItems({
        adminSettings: `${t('page.name.adminSettings.accessibility')}`,
      })
    )
  }, [dispatch, t])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        color: 'text.light',
      }}
    >
      <TabContext value={tabIndex}>
        <Box>
          <Tabs
            value={tabIndex}
            onChange={(_, newValue) => setTabIndex(newValue)}
            aria-label={t('page.adminsPage.accessibility.tabAriaLabel')}
          >
            <StyledTab
              value="roles"
              label={t('page.adminsPage.accessibility.roles')}
              id="tab-roles"
              aria-controls="tabpanel-roles"
            />
            <StyledTab
              value="permissions"
              label={t('page.adminsPage.accessibility.permissions')}
              id="tab-permissions"
              aria-controls="tabpanel-permissions"
            />
          </Tabs>
        </Box>
        <TabPanel
          value="roles"
          id="tabpanel-roles"
          aria-labelledby="tab-roles"
          sx={{ padding: { xs: '24px 0px', sm: '24px 24px' } }}
        >
          <RoleDetailTable />
        </TabPanel>
        <TabPanel
          value="permissions"
          id="tabpanel-permissions"
          aria-labelledby="tab-permissions"
          sx={{ padding: { xs: '24px 0px', sm: '24px 24px' } }}
        >
          <PermissionsTable />
        </TabPanel>
      </TabContext>
    </Box>
  )
}

export default AccessibilitySettingsView
